import { cx } from '@emotion/css';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { FC } from 'react';

import { StoryCard } from '_components/common/StoryCard';
import * as S from '_features/story/components/header/header.component.styles';
import { storyConfig } from '_features/story/story.config';
import { LinkStoryDetails, numberWithDots } from '_features/story/utils';

export type HeaderComponentProps = {
  story?: LinkStoryDetails;
};

export const HeaderComponent: FC<HeaderComponentProps> = (props) => {
  const { story } = props;
  const { t } = useTranslation(storyConfig.i18nNamespaces);
  const business = story?.business;

  return (
    <S.Header
      data-testid="story-header"
      className={cx(
        business?.type === 'client' ? 'bg-demand-200' : 'bg-supply-200',
        'pt-24 lg:pt-16 lg:pb-8 relative',
      )}>
      <div className="container-md layout-gt-xs-row layout-column layout-align-start-stretch">
        <div className="flex-grow text-left p-8 layout-column layout-align-center-start">
          <h1 className={cx(business?.type === 'client' ? 'text-demand-900' : 'text-supply-900', 'serif bold mb-4')}>
            {story?.title}
          </h1>
          <p className={cx(business?.type === 'client' ? 'text-demand-700' : 'text-supply-700', 'h6 bold')}>
            {story?.subTitle}
          </p>
          <p className={cx(business?.type === 'client' ? 'text-demand-700' : 'text-supply-700', 'h6 mb-8')}>
            {story?.tagline}
          </p>
          <div className="layout-gt-xs-row layout-column layout-align-start-start">
            <p
              className={cx(
                business?.type === 'client' ? 'bg-demand-300 text-demand-900' : 'bg-supply-300 text-supply-900',
                'py-1 px-3 rounded-sm',
              )}>
              <b>{t('story:header.tags.project.title')}:</b> {business?.projectType}
            </p>
            <p
              className={cx(
                business?.type === 'client' ? 'bg-demand-300 text-demand-900' : 'bg-supply-300 text-supply-900',
                'sm:ml-2 sm:mt-0 mt-2 py-1 px-3 rounded-sm',
              )}>
              <b>{t('story:header.tags.budget.title')}:</b> €{numberWithDots(business?.projectBudget)}
            </p>
          </div>
        </div>
        <S.CardWrapper>
          <StoryCard
            linkStory={story}
            className={cx(business?.type === 'client' ? 'border-demand-500' : 'border-supply-500')}
          />
        </S.CardWrapper>
      </div>
    </S.Header>
  );
};
